export default __webpack_public_path__ + "static/media/JuniorSantos.5e1cd659.jpg";